import ReactQuill from 'react-quill';
import { cmsPrompt } from '../../components/CmsModal';

const Quill = ReactQuill.Quill;
const BlockEmbed = Quill.import('blots/block/embed');

class ActionButtonBlot extends BlockEmbed {
  static create(value: { url: string; text: string; target?: string }) {
    let node = super.create();
    const target = value.target || '_blank';
    node.setAttribute('contenteditable', 'false');
    node.setAttribute('data-url', value.url);
    node.setAttribute('data-text', value.text);
    node.setAttribute('data-target', target);

    const relAttr = target === '_blank' ? ' rel="noreferrer"' : '';
    node.innerHTML = `<a href="${value.url}" target="${target}"${relAttr} class="ipf-action-btn" style="display: inline-block; padding: 14px 36px; border-radius: 30px; background-color: #121E5C; color: #FFFFFF; font-size: 16px; font-weight: 700; text-decoration: none; cursor: pointer; transition: background-color 0.2s;">${value.text}</a>`;
    node.style.textAlign = 'center';
    node.style.margin = '30px 0';

    // Edit on click — attach handler directly to the wrapper node
    node.addEventListener('click', (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const currentUrl = node.getAttribute('data-url') || '';
      const currentText = node.getAttribute('data-text') || '';
      const currentTarget = node.getAttribute('data-target') || '_blank';

      cmsPrompt({
        title: 'Edit Action Button',
        description: 'Modify the button URL, text, or link behavior.',
        icon: 'bi bi-pencil-square',
        fields: [
          { id: 'url', label: 'Button URL', placeholder: 'e.g. /contact or https://example.com', type: 'text', required: true, defaultValue: currentUrl },
          { id: 'text', label: 'Button Text', placeholder: 'e.g. Learn More', type: 'text', required: true, defaultValue: currentText },
          { id: 'newTab', label: 'Open in new tab', type: 'toggle' as any, defaultValue: currentTarget === '_blank' ? 'true' : 'false' },
        ],
        submitText: 'Update Button',
      }).then((values) => {
        if (!values) return;
        const { url, text, newTab } = values;
        if (!url || !text) return;

        const newTarget = newTab === 'true' ? '_blank' : '_self';
        const newRel = newTarget === '_blank' ? ' rel="noreferrer"' : '';

        node.setAttribute('data-url', url);
        node.setAttribute('data-text', text);
        node.setAttribute('data-target', newTarget);
        node.innerHTML = `<a href="${url}" target="${newTarget}"${newRel} class="ipf-action-btn" style="display: inline-block; padding: 14px 36px; border-radius: 30px; background-color: #121E5C; color: #FFFFFF; font-size: 16px; font-weight: 700; text-decoration: none; cursor: pointer; transition: background-color 0.2s;">${text}</a>`;

        // Trigger Quill to recognize the change
        const qlContainer = node.closest('.ql-container');
        if (qlContainer) {
          const quillInstance = Quill.find(qlContainer);
          if (quillInstance) {
            // Force Quill to detect the DOM mutation
            quillInstance.update('user');
          }
        }
      });
    });

    return node;
  }

  static value(node: HTMLElement) {
    return {
      url: node.getAttribute('data-url') || '',
      text: node.getAttribute('data-text') || '',
      target: node.getAttribute('data-target') || '_blank'
    };
  }
}
ActionButtonBlot.blotName = 'actionButton';
ActionButtonBlot.tagName = 'div';
ActionButtonBlot.className = 'ipf-action-button-wrapper';

Quill.register(ActionButtonBlot, true);

const icons = Quill.import('ui/icons');
icons['actionButton'] = '<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="12" height="8" rx="2"></rect><line x1="6" y1="9" x2="12" y2="9"></line></svg>';
